import React, { memo } from 'react';
import {
  AssetPromoCard,
  IconPromoCard,
  PromoCard as SatoPromoCard,
  PromoCardProps,
} from '@sato/components';

import { Link } from '@components/common/Link';

import { IPromoCard, ParsedEntry } from '../types';

export const PromoCard = memo(
  ({
    internalName: _internalName,
    contentType: _contentType,
    colorVariant: _colorVariant,
    richText,
    body: bodyProp,
    icon,
    url,
    linkText,
    linkVariant = 'linkButton',
    variant = 'image',
    image,
    ...promoCard
  }: ParsedEntry<IPromoCard> & {
    className?: string;
    variant?: PromoCardProps['variant'];
  }) => {
    const body = richText ?? bodyProp;

    // early exit if there's no content for the current active language
    if (!body && !promoCard.heading && !linkText) return null;

    const { src = '', alt = '', srcType = 'image' } = image ?? {};

    let variantProps;

    if (variant === 'framedIcon') {
      variantProps = {
        variant,
        icon: icon?.icon,
      } satisfies IconPromoCard;
    } else if (icon?.icon) {
      variantProps = {
        variant: 'icon',
        icon: icon.icon,
      } satisfies IconPromoCard;
    } else {
      variantProps = {
        variant,
        src,
        alt,
        srcType,
        source: 'contentful',
      } satisfies AssetPromoCard;
    }

    if (linkVariant === 'linkButton') {
      return (
        <SatoPromoCard
          {...promoCard}
          {...variantProps}
          body={body}
          bodyLinkComponent={Link}
          wrapperComponent="div"
          {...(url && {
            buttonProps: {
              wrapperComponent: Link,
              to: url,
              children: linkText,
            },
          })}
        />
      );
    }

    return (
      <SatoPromoCard
        {...promoCard}
        {...variantProps}
        wrapperComponent="div"
        {...(url ? { wrapperComponent: Link, to: url } : undefined)}
        body={body}
        bodyLinkComponent={Link}
        buttonProps={
          linkText
            ? { children: linkText, wrapperComponent: 'span' }
            : undefined
        }
      />
    );
  }
);
